module.exports = __webpack_public_path__ + "img/883d4df.png";